import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Toasted from 'vue-toasted'

import App from './app.vue'
import router from '@router'
import store from '@state/store'
import config from '@src/config'
import directives from '@src/utils/directives'
import '@components/_globals'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

const sentryDsn = config.sentryDsn

Sentry.init({
  dsn: sentryDsn,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  environment: process.env.NODE_ENV,
})

Vue.component('v-style', {
  render: function(createElement) {
    return createElement('style', this.$slots.default)
  },
})

Vue.use(Toasted)

const app = new Vue({
  router,
  store,
  directives,
  beforeCreate: () => store.dispatch('initApp'),
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
